export default __webpack_public_path__ + "static/media/juseno_1.d081e69d.png";